import React from 'react';
import { makeStyles, Typography } from '@material-ui/core';

export const ErrorComponent: React.FC<{ errorMessage: string }> = (props) => {
  const classes = useStyles();
  return (
    <div>
      <div className={classes.container} >
        <Typography variant="h6" color="primary" >
          {props.errorMessage}
        </Typography>
      </div>
    </div>
  );
}

const useStyles = makeStyles(theme => {
  return ({
    container: {
      display: 'flex',
      flexDirection: 'column',
      height: '80vh',
      overflow: 'hidden',
      justifyContent: 'center',
      alignItems: 'center',
    },
  });
});
